import { IMapper } from '@/mappers/index'
import { IAccruals, IAccrualsResponse, ICreateAccruals, ICreateAccrualsResponse } from '@/types/accruals'

export const accrualsMap: IMapper<IAccrualsResponse, IAccruals> = {
  id: 'id',
  personal_account_id: 'personalAccountId',
  personal_account: 'personalAccount',
  managing_organization_id: 'managingOrganizationId',
  house_id: 'houseId',
  balance: 'balance',
  amount: 'amount',
  amount_date: 'amountDate',
  additional_info: 'additionalInfo',
  created_at: 'createdAt',
  updated_at: 'updatedAt',
  deleted_at: 'deletedAt'
}

export const createAccrualMap: IMapper<ICreateAccrualsResponse, ICreateAccruals> = {
  moid: 'moid',
  personal_account_id: 'personalAccountId',
  balance: 'balance',
  amount: 'amount',
  amount_date: 'amountDate'
}
